export default __webpack_public_path__ + "static/media/Zara cyprus.536f8bb1.png";